import { format } from 'date-fns';

export default function dateJsToReadableDate(date: Date | string): string {
  return format(new Date(date),  'dd/MM/yyyy \'às\' HH\'h\'mm\'m\'');
}
